var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"model":_vm.val},on:{"input":function($event){_vm.val = $event}}},_vm._l((_vm.ratings),function(r){return _c('option',{key:r.score,domProps:{"value":r.score}},[_c('span',[_vm._v(_vm._s('★'.repeat(r.score))+" "+_vm._s(r.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }